import React from 'react'

const Loader = () => {
  return (
    <div className='spinner-loader'>
      <div className='loader'></div>
    </div>
  )
}

export default Loader
